import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IModulesPage } from "./types";

const ModulesPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [modules, setModules] = useState<IModulesPage[]>([]);
  const [paidModuleIds, setPaidModuleIds] = useState<string[]>([]);
  const [approvedModuleIds, setApprovedModuleIds] = useState<string[]>([]);

  const token = localStorage.getItem("token");
  const studentId = localStorage.getItem("id");

  useEffect(() => {
    if (!token || !studentId) return;

    const fetchData = async () => {
      try {
        // Obtener todos los módulos
        const modulesRes = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/student/modules/${studentId}/modules`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const allModules = await modulesRes.json();

        // Obtener módulos pagados y aprobados
        const studentRes = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/student/modules/${studentId}/full`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const studentData = await studentRes.json();

        setModules(allModules.sort((a: any, b: any) => a.week - b.week));
        setPaidModuleIds(studentData.paidModules);
        setApprovedModuleIds(studentData.approvedModules);
        setIsLoading(false);
      } catch (err) {
        console.error("❌ Error cargando datos:", err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [token, studentId]);

  // Filtrado de módulos por categoría
  const availableModules = modules.filter(
    (mod) => paidModuleIds.includes(mod._id) && !approvedModuleIds.includes(mod._id)
  );

  const pastModules = modules.filter(
    (mod) => approvedModuleIds.includes(mod._id)
  );

  const upcomingModules = modules.filter(
    (mod) => !paidModuleIds.includes(mod._id) && !approvedModuleIds.includes(mod._id)
  );

  const renderModuleRow = (mod: IModulesPage, showLink = false) => (
    <div
      key={mod._id}
      className="flex flex-col sm:flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-12 text-sm sm:text-base"
    >
      {showLink ? (
        <a
          onClick={() => navigate(`/students/${studentId}/modules/${mod._id}`)}
          className="text-[#2755ee] font-sourceSans cursor-pointer"
        >
          {mod.title}
        </a>
      ) : (
        <p className="font-sourceSans">{mod.title}</p>
      )}
      <div className="flex justify-between sm:justify-end sm:gap-8 mt-1 sm:mt-0">
        {mod.description && <p className="font-sourceSans hidden sm:block">{mod.description}</p>}
        <p className="font-sourceSans">Semana {mod.week}</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen w-full px-4 sm:px-8 flex flex-col">
      <div className="flex-1 overflow-y-auto py-8">
        <div className="flex flex-col items-start gap-4">
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-12">Módulos disponibles</h2>
          <div className="w-full flex flex-col">
            {isLoading ? (
              <p>Cargando módulos...</p>
            ) : availableModules.length > 0 ? (
              availableModules.map((mod) => renderModuleRow(mod, true))
            ) : (
              <p className="font-sourceSans px-4">No hay módulos disponibles</p>
            )}
          </div>
        </div>

        <div className="flex flex-col items-start gap-4 mt-12">
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Módulos pasados</h2>
          <div className="w-full flex flex-col">
            {pastModules.length > 0 ? (
              pastModules.map((mod) => renderModuleRow(mod, true))
            ) : (
              <p className="font-sourceSans px-4">No hay módulos pasados</p>
            )}
          </div>
        </div>

        <div className="flex flex-col items-start gap-4 mt-12">
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Próximos módulos</h2>
          <div className="w-full flex flex-col">
            {upcomingModules.length > 0 ? (
              upcomingModules.map((mod) => renderModuleRow(mod))
            ) : (
              <p className="font-sourceSans px-4">No hay módulos próximos</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModulesPage;
